import React, { useEffect, useRef } from 'react'
import { DeleteModalProps } from '../../types/interface'
import styles from '../../styles/ModalFooter.module.css'


const DeleteModal = ({status, deleteHandler, cancelHandler, content}: DeleteModalProps) => {
    
    return (
        <div className={`modal fade ${styles.deleteModal}`} id="deleteModal" data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="deleteModalLabel">Delete This Subscription</h5>
                    </div>
                    <div className="modal-body">
                        <p>Are you Sure you want to delete ?</p>
                        <div>{content}</div>
                    </div>
                    <div className={`modal-footer d-flex justify-content-between ${styles.modalFooter}`}>
                        {
                            <div className={!status ? styles.actionsBlock : 'invisible'}>
                                <button type="button" className="btn btn-secondary dismiss-deleteModal" data-bs-dismiss="modal" onClick={cancelHandler}>Cancel</button>
                                <button type="submit" className="btn btn-primary" onClick={deleteHandler}>Delete</button>
                            </div>
                        }
                        {
                            <div className={`${styles.actionFailed} ${status === 'failed' ? styles.slideIn : 'invisible'}`}>
                                Oops! Delete Failed
                            </div>
                        }
                        {
                            <div className={`${styles.actionSuccess} ${status === 'success' ? styles.slideIn : 'invisible'}`}>
                                Deleted Successfully!
                            </div>
                        }
                        {
                            <div className={`${styles.actionProgress} ${status === 'progress' ? styles.slideIn : 'invisible'}`}>
                                Deleting...
                                <div className={styles.cdLoading}></div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DeleteModal
